import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/i18n/LangContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { StickyBottomBanner } from "@/components/ads/StickyBottomBanner";
import Landing from "@/pages/Landing";
import Converter from "@/pages/Converter";
import ExcelAnalysis from "@/pages/ExcelAnalysis";
import PdfEditor from "@/pages/PdfEditor";
import ImageToPdf from "@/pages/ImageToPdf";
import Faq from "@/pages/Faq";
import CompressPdf from "@/pages/CompressPdf";
import { GuideHub, GuideArticle } from "@/pages/Guides";
import Glossary from "@/pages/Glossary";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";

function App() {
  return (
    <LangProvider>
      <div className="App flex min-h-screen flex-col pb-32">
        <BrowserRouter>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/pdf-excel" element={<Converter target="excel" />} />
              <Route path="/pdf-word" element={<Converter target="word" />} />
              <Route path="/analisi-excel" element={<ExcelAnalysis />} />
            <Route path="/modifica-pdf" element={<PdfEditor />} />
              <Route path="/immagine-pdf" element={<ImageToPdf />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/comprimi-pdf" element={<CompressPdf />} />
              <Route path="/guide" element={<GuideHub />} />
              <Route path="/guide/:slug" element={<GuideArticle />} />
              <Route path="/glossario-pdf" element={<Glossary />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
        <StickyBottomBanner />
        <Toaster position="top-center" richColors />
      </div>
    </LangProvider>
  );
}

export default App;
